// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a81207ba","239":"bbcbc978","667":"a81a4227"}[chunkId] + ".chunk.js";
};